import { searchReport } from '@/reports/searchReport';
import type { AncestorRequestBody } from '@/reports/searchReport';

export interface SearchParams {
  first_name: string;
  last_name: string;
  city: string;
  state: string;
  country: string;
  date_of_birth: string;
  date_of_death: string;
  ip_address: string;
  family_search_id: string;
}

export async function ancestorSearch(searchParams: SearchParams) {
  const body: AncestorRequestBody = {
    report_type: 'ancestry_report',
    meta: {
      first_name: searchParams.first_name,
      last_name: searchParams.last_name,
      city: searchParams.city,
      state: searchParams.state,
      country: searchParams.country,
      date_of_birth: searchParams.date_of_birth,
      date_of_death: searchParams.date_of_death,
      ip_address: searchParams.ip_address,
      family_search_id: searchParams.family_search_id,
      report_flags: [],
    },
  };

  return await searchReport(body);
}
